import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ITokenResponse } from 'app/core/authentication/models/token-response';
import { UrlService } from 'app/core/http/url.service';
import { UserNameModel } from 'app/shared/models/user-name.model';
import { UpdatePasswordModel } from '../models/update-password-model';
import { UserInfoSettings } from '../models/user-info-settings.model';

@Injectable({
  providedIn: 'root'
})
export class AccountSettingsDataService {
  private readonly urlService = inject(UrlService);
  private readonly httpClient = inject(HttpClient);

  public setLocale(locale: string): Observable<any> {
    const url = this.urlService.buildServerApiUrl('Account', 'Locale');

    return this.httpClient.post<any>(url, { Value: locale });
  }

  public getUserRolesInfo(): Observable<any> {
    const url = this.urlService.buildServerApiUrl('Account', 'UserRolesInfo');

    return this.httpClient.get<any>(url);
  }

  public getUser(userid: string): Observable<UserNameModel> {
    const url = this.urlService.buildServerApiUrl('Account', 'User');
    const params = new HttpParams().set('UserId', userid);

    return this.httpClient.get<UserNameModel>(url, { params });
  }

  public verifyEmail(code: string): Observable<ITokenResponse> {
    const url = this.urlService.buildServerApiUrl('Account', 'verifyemail', code);

    return this.httpClient.post<ITokenResponse>(url, {});
  }

  public getSettingsInfo(): Observable<UserInfoSettings> {
    const url = this.urlService.buildServerApiUrl('account', 'userinfo', 'settings');

    return this.httpClient.get<UserInfoSettings>(url);
  }

  public saveName(userName: UserNameModel): Observable<UserNameModel> {
    const url = this.urlService.buildServerApiUrl('account', 'userinfo', 'name');

    return this.httpClient.post<UserNameModel>(url, userName);
  }

  public deleteUser(): Observable<void> {
    const url = this.urlService.buildServerApiUrl('account', 'userinfo');

    return this.httpClient.delete<void>(url);
  }

  public updatePassword(request: UpdatePasswordModel): Observable<void> {
    const url = this.urlService.buildServerApiUrl('account', 'changepassword');

    return this.httpClient.post<void>(url, { NewPassword: request.newPassword, OldPassword: request.currentPassword });
  }

  public saveEmail(email: string): Observable<any> {
    const url = this.urlService.buildServerApiUrl('account', 'contactinfo', 'email');

    return this.httpClient.post<any>(url, { Value: email });
  }

  public resendEmailVerification(): Observable<void> {
    const url = this.urlService.buildServerApiUrl('account', 'resendverifyemail');

    return this.httpClient.post<void>(url, {});
  }
}
